import { metric, dynos, formatDelay } from "./helpers"

// Shared by the capacity-notifier form controller and the per-schedule override
// controller, which both resolve the same effective threshold/delay (the entered
// value, or a placeholder default when blank) and render the same description
// sentences. The override controller passes `suffix` (" during this schedule") to
// tack onto each sentence.

export function effectiveThreshold(raw, placeholder) {
  const t = parseInt(raw)
  return t > 0 ? t : placeholder
}

export function effectiveDelay(raw, placeholder) {
  const d = parseInt(raw)
  return !isNaN(d) && raw !== "" ? d : placeholder
}

export function thresholdDescription(threshold, suffix = "") {
  return `A notification is sent when running ${dynos(`${threshold} or more dynos`)}${suffix}.`
}

export function delayDescription(delay, suffix = "") {
  if (delay === 0)
    return `Sent immediately, with no delay.`
  return `The count must hold for ${metric(formatDelay(delay))}${suffix}.`
}

// Combined summary on the configure form (and keep wording aligned with the
// server-side capacity_notifier_summary helper on the show card).
export function combinedDescription(threshold, delay) {
  if (delay === 0)
    return `Send a notification immediately when running ${dynos(`${threshold} or more dynos`)}.`
  return `Send a notification when running ${dynos(`${threshold} or more dynos`)} for at least ${metric(formatDelay(delay))}.`
}
